const IN_PROGRESS_FRAGMENTS = [ 'queued', 'parsing', 'updating' ];

// True while a submitted list upload is still being queued, parsed or synced.
export const isInProgressStatus = (status?: string | null): boolean => {
  const normalized = (status || '').toLowerCase();
  return IN_PROGRESS_FRAGMENTS.some(fragment => normalized.includes(fragment));
};

// Whole number between 0 and 100, or null when the server gave us nothing usable.
export const clampPercent = (percent?: number | null): number | null => {
  if (typeof percent !== 'number' || Number.isNaN(percent)) return null;
  return Math.min(100, Math.max(0, Math.round(percent)));
};
